import { type ApiContainerAction } from '@Model';

/** Whether the row carries a remark. */
export const hasRemarks = (action: ApiContainerAction) => action.remarks !== '';

/** Whether the row is billed as a container type other than the one it plans. */
export const billsAsAnotherType = (action: ApiContainerAction) =>
    Boolean(action.billed_as.foreign_key) && action.billed_as.foreign_key !== action.container_type.foreign_key;
